<template>
    <div>
        <div v-for="(file, index) in files" :key="index" class="lb-media-link">
            <a
                :href="file.url"
                target="_blank"
                class="button is-link is-fullwidth"
            >
                <span class="icon">
                    <i :class="file.mimeType | iconForMime" class="fas" />
                </span>
                <span>{{ file.name }}</span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    filters: {
        iconForMime(mime) {
            if (mime.indexOf('pdf') > -1) {
                return 'fa-file-pdf';
            }

            return 'fa-file';
        },
    },
    props: {
        files: {
            type: Array,
            default() {
                return [];
            },
        },
    },
};
</script>

<style></style>
